import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactComponent as NoDataCardIcon } from '../../../../../images/icons/no_tab_data_icon.svg';
import { darkPurple, dimGrey } from '../../../../../mainTheme';

const NoTabDataCard = () => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box sx={{ mb: 2, color: 'text.secondary' }}>
        <NoDataCardIcon />
      </Box>
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          color: darkPurple,
          fontSize: '18px',
          fontWeight: 500,
          lineHeight: '24px',
          letterSpacing: '0.2px',
        }}
      >
        No data
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: dimGrey,
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '20px',
          letterSpacing: '0.2px',
        }}
      >
        Select another tab
      </Typography>
    </Box>
  );
};

export default NoTabDataCard;
